import { classNames } from '@/shared/utils';
import { NavLink } from 'react-router-dom';
import styles from '../../DrawerProfile.module.css';
import { Badge } from 'antd';
import { memo, useMemo } from 'react';
import { NAVIGATION_ITEMS } from '@/shared/constants';
import { useSelector } from 'react-redux';

const NavItem = ({ open, item, isActive }) => {
  const showUnreadIndicator = useSelector(state => state.ui.showUnreadIndicator);
  const translationGroup = useSelector(state => state.userInfo.translationGroup);

  const BADGE_OPTIONS = useMemo(
    () => ({
      [NAVIGATION_ITEMS.GROUP_TRANSLATIONS.key]: typeof translationGroup === 'string',
      [NAVIGATION_ITEMS.TRANSLATION.key]: showUnreadIndicator,
    }),
    [translationGroup, showUnreadIndicator]
  );

  return (
    <NavLink to={item.link} className={styles.navHover} key={item.key}>
      <div
        className={classNames(styles.navHover, {
          [styles.activeNavItem]: isActive,
        })}
      >
        <div className={classNames(styles.navBarIcon, { [styles.navBarIconOpened]: open })}>{item.icon}</div>
        <span className={classNames(styles.textContainer, { [styles.textContainerOpened]: open })}>
          {BADGE_OPTIONS[item.key] && <Badge dot={BADGE_OPTIONS[item.key]} className={styles.badge} />}
          {item.label}
        </span>
      </div>
    </NavLink>
  );
};

export default memo(NavItem);
